import {
  Tabs,
} from "antd";
import React, {
  forwardRef,
  useState,
  useRef,
} from "react";
// import "./CompletedTable.scss";
import VendorMWorker from "@/views/AccountPayable/VendorMWorker";
import Vendors from "@/views/AccountPayable/Vendors";

const MainTable = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState('1');
  const vendorsRef = useRef();
  const workerRef = useRef();

  const handleTabChange = (key) => {
    setTabsKey(key);
    // 切换时调用子组件的刷新方法
    if (key === '1') {
      vendorsRef.current?.refresh?.();
    } else if (key === '2') {
      workerRef.current?.refresh?.();
    }
  };

  return (
    <div>
      <Tabs 
        activeKey={tabsKey}
        forceRender
        items={[
          {key: '1', label: "Vendors", children: <Vendors ref={vendorsRef} />},
          {key: '2', label: "Monthly Worker", children: <VendorMWorker ref={workerRef} />},
        ]}
        onChange={handleTabChange}
      />
    </div>
  );
});
export default MainTable;